// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meal-options-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.meal-options-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border: 1px solid #D9D9D9;
  border-radius: 18px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}
.meal-options-list-item-badge {
  padding: 4px 12px;
  background-color: #F0F0F0;
  color: #8C8C8C;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.meal-options-list-item:hover:not(.disabled) {
  border-color: #CC9900;
}
.meal-options-list-item.selected {
  border-color: #CC9900;
  background-color: #FFF9E6;
}
.meal-options-list-item.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #FAFAFA;
}
.meal-options-list-item.disabled .timeslot-time {
  color: #BFBFBF;
}
.meal-options-list-item .item-price {
  font-size: 18px;
  color: #8E7E54;
  font-weight: 500;
}
.meal-options-header {
  margin-block: 16px 24px;
  line-height: 1;
}
.meal-options-header h4 {
  font-size: 16px;
}
.meal-options-header p {
  font-size: 14px;
}
/*# sourceMappingURL=MealOptionsSelector.css.map */`, "",{"version":3,"sources":["webpack://./MealOptionsSelector.less","webpack://./src/containers/BookingPage/components/MealOptionsSelector.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;ACCJ;ADCI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;ACCR;ADCQ;EACI,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ACCZ;ADEQ;EACI,qBAAA;ACAZ;ADGQ;EACI,qBAAA;EACA,yBAAA;ACDZ;ADIQ;EACI,mBAAA;EACA,YAAA;EACA,yBAAA;ACFZ;ADDQ;EAMQ,cAAA;ACFhB;ADlCI;EAyCQ,eAAA;EACA,cAAA;EACA,gBAAA;ACJZ;ADUA;EACI,uBAAA;EACA,cAAA;ACRJ;ADMA;EAKQ,eAAA;ACRR;ADGA;EASQ,eAAA;ACTR;AACA,kDAAkD","sourcesContent":[".meal-options-list{\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    &-item {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 16px 20px;\n        border: 1px solid #D9D9D9;\n        border-radius: 18px;\n        background-color: #ffffff;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        position: relative;\n\n        &-badge {\n            padding: 4px 12px;\n            background-color: #F0F0F0;\n            color: #8C8C8C;\n            border-radius: 12px;\n            font-size: 12px;\n            font-weight: 500;\n        }\n\n        &:hover:not(.disabled) {\n            border-color: #CC9900;\n        }\n\n        &.selected {\n            border-color: #CC9900;\n            background-color: #FFF9E6;\n        }\n\n        &.disabled {\n            cursor: not-allowed;\n            opacity: 0.5;\n            background-color: #FAFAFA;\n\n            .timeslot-time {\n                color: #BFBFBF;\n            }\n        }\n\n        .item-price{\n            font-size: 18px;\n            color: #8E7E54;\n            font-weight: 500;\n        }\n    }\n\n}\n\n.meal-options-header{\n    margin-block: 16px 24px;\n    line-height: 1;\n\n    h4{\n        font-size: 16px;\n    }\n\n    p{\n        font-size: 14px;\n    }\n}",".meal-options-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.meal-options-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border: 1px solid #D9D9D9;\n  border-radius: 18px;\n  background-color: #ffffff;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n.meal-options-list-item-badge {\n  padding: 4px 12px;\n  background-color: #F0F0F0;\n  color: #8C8C8C;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n.meal-options-list-item:hover:not(.disabled) {\n  border-color: #CC9900;\n}\n.meal-options-list-item.selected {\n  border-color: #CC9900;\n  background-color: #FFF9E6;\n}\n.meal-options-list-item.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  background-color: #FAFAFA;\n}\n.meal-options-list-item.disabled .timeslot-time {\n  color: #BFBFBF;\n}\n.meal-options-list-item .item-price {\n  font-size: 18px;\n  color: #8E7E54;\n  font-weight: 500;\n}\n.meal-options-header {\n  margin-block: 16px 24px;\n  line-height: 1;\n}\n.meal-options-header h4 {\n  font-size: 16px;\n}\n.meal-options-header p {\n  font-size: 14px;\n}\n/*# sourceMappingURL=MealOptionsSelector.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
